import events from './events';

const global = Object.assign({}, window.SLXCOM || {});
export default global;

Object.defineProperties(global, {
	events: {
		value: events,
		writable: false,
	},
	MAP_KEY: {
		value: 'AIzaSyBbk7v4dByRwu_blRZANakweiyBllBS4ew', // geralds api key
		//value: 'AIzaSyBVPqdD4bk970wtJJGPueuDpzMUgjcRZkQ', // selux api key
		writable: false,
	}
});

// Remove nojs class
document.getElementsByTagName('html')[0].classList.remove('nojs');
